var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompas = function SvgCompas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    fill: "none",
    viewBox: "0 0 96 123"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCF6F",
    d: "M47.885 122.81c26.446 0 47.884-21.222 47.884-47.4 0-26.179-21.439-47.4-47.884-47.4C21.439 28.01 0 49.23 0 75.41c0 26.178 21.439 47.4 47.885 47.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M47.885 115.984c22.639 0 40.991-18.166 40.991-40.576s-18.352-40.576-40.99-40.576c-22.64 0-40.991 18.166-40.991 40.576s18.352 40.576 40.99 40.576Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M54.626 82.09 26 98.144c-.691.395-1.49-.37-1.09-1.081L41.11 68.724"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#345B68",
    d: "M54.626 82.088 70.828 53.75c.399-.686-.373-1.477-1.091-1.081L41.11 68.723"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M53.07 74.643c-.428-2.838-3.095-4.795-5.959-4.372-2.863.423-4.838 3.067-4.411 5.904.427 2.837 3.094 4.795 5.957 4.372 2.864-.423 4.84-3.067 4.412-5.904Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCF6F",
    d: "M47.885 28.35c-7.906 0-14.32-6.35-14.32-14.175C33.565 6.35 39.979 0 47.885 0c7.905 0 14.32 6.35 14.32 14.175 0 7.826-6.415 14.175-14.32 14.175Zm0-23.08c-4.978 0-8.997 4.005-8.997 8.905 0 4.901 4.046 8.906 8.997 8.906 4.95 0 8.996-4.005 8.996-8.906 0-4.9-4.046-8.905-8.996-8.905Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCF6F",
    d: "M50.892 14.15h-5.989c-1.617 0-2.927 1.297-2.927 2.898v11.488c0 1.6 1.31 2.898 2.928 2.898h5.988c1.617 0 2.928-1.298 2.928-2.898V17.048c0-1.6-1.31-2.898-2.928-2.898Z"
  })));
};
export default SvgCompas;